import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from '@app/app.component';
import { appConfig } from '@app/app.config';
import { environment } from '@env/environment';
import { Amplify } from 'aws-amplify';

Amplify.configure(environment.aws);

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
